<template>
  <div class="mt-6">
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="mt-6">
        <v-card elevation="6">
          <div class="pa-4">
            <span style="font-size: 24px">รายละเอียดการนับสต๊อก</span>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="detailHeader" :items="get_details" :footer-props="footer_Props" :loading="loading_table" :items-per-page.sync="item_page" :search="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td class="hidden_line">
                    <div v-if="dataDetail.item.product_code != null">{{ dataDetail.item.product_code }}</div>
                    <div v-else>-</div>
                  </td>
                  <td class="hidden_line">{{ dataDetail.item.product_name }}</td>
                  <td class="text-center hidden_line">{{ dataDetail.item.qty_sml }}</td>
                  <td class="hidden_line"> {{ dataDetail.item.unit_name }}</td>
                  <td class="text-center hidden_line">
                    <div>{{ dataDetail.item.count_qty }}</div>
<!--                    <div v-else>0</div>-->
                  </td>
                  <td class="text-center hidden_line">
                    <div v-if="dataDetail.item.diff_qty < 0" style="color: red">{{ dataDetail.item.diff_qty }}</div>
                    <div v-if="dataDetail.item.diff_qty == 0">0</div>
                    <div v-if="dataDetail.item.diff_qty > 0" style="color: #86bc3a">{{ dataDetail.item.diff_qty }}</div>
                  </td>
                  <td class="text-center hidden_line">
                    <div v-if="dataDetail.item.confirm_count < 0" style="color: red">{{ dataDetail.item.confirm_count }}</div>
                    <div v-else-if="dataDetail.item.confirm_count == 0">{{ dataDetail.item.confirm_count }}</div>
                    <div v-else-if="dataDetail.item.confirm_count > 0" style="color: #86bc3a">{{ dataDetail.item.confirm_count }}</div>
                    <div v-else>{{ dataDetail.item.confirm_count }}</div>
                  </td>
                  <td class="hidden_line">{{ dataDetail.item.user_confirm_name }}</td>
<!--                  <td>{{ dataDetail.item.note }}</td>-->
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Count_Details",
  data() {
    return {
      loading_page: false,
      search: null,
      sortBy: '',
      sortDesc: false,
      loading_table: false,
      get_details: [],
      item_page: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      detailHeader: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวนคงคลัง',
          value: 'qty_sml',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วย',
          value: 'unit_name',
          fixed: true,
          width: '100px',
        },
        {
          text: 'นับได้',
          value: 'count_qty',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนต่างก่อนปรับ',
          value: 'diff_qty',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ส่วนต่างหลังปรับ',
          value: 'confirm_count',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ผู้ปรับส่วนต่าง',
          value: 'user_confirm_name',
          fixed: true,
          width: '200px',
        },
      ],
    }
  },
  methods: {
    getStock_deatail() {
      this.loading_page = true
      this.loading_table = true
      HTTP.post('/stocks/getproductinstock', {
        stock_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.loading_table = false
          this.get_details = res.data.object
        }
      })
    }
  },
  mounted() {
    this.getStock_deatail();
  }
}
</script>

<style scoped>

</style>
